import React from "react";
import { Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

/**
 * Botón «Ver detalle» de las tablas del panel (Actividad y Simulaciones), en lugar del «+» de 16 x 16 px de AntD.
 *
 * Por qué: en el celular un blanco de 16 px no se acierta con el dedo, y la ayuda decía «Toca una fila para ver el detalle»
 * cuando tocar la fila no hacía nada. Ahora la fila entera abre el detalle (`expandRowByClick` en la tabla) y este botón
 * mide 40 x 40 px (el mínimo táctil), tiene nombre accesible, avisa si está abierto (`aria-expanded`) y se alcanza con teclado.
 *
 * `stopPropagation`: con `expandRowByClick` el clic en el botón también llega a la fila, y abrir y cerrar a la vez lo dejaría igual.
 */
export const LADO_TACTIL_PX = 40;

export function expansorFila<T>({
  expanded,
  onExpand,
  record,
}: {
  expanded: boolean;
  onExpand: (record: T, e: React.MouseEvent<HTMLElement>) => void;
  record: T;
}): React.ReactNode {
  return (
    <Button
      type="text"
      aria-label={expanded ? "Ocultar detalle" : "Ver detalle"}
      aria-expanded={expanded}
      icon={expanded ? <MinusOutlined /> : <PlusOutlined />}
      style={{ width: LADO_TACTIL_PX, height: LADO_TACTIL_PX, minWidth: LADO_TACTIL_PX }}
      data-testid="expansor-fila"
      onClick={(e) => {
        e.stopPropagation();
        onExpand(record, e);
      }}
    />
  );
}
